import React from "react";
import { Grid, Box, Typography, Avatar } from "@mui/material";
import "./WarningARModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";

import CompDirection from "../../../themes/CompDirection";
import { themes } from "../../../themes/themes";
import TakeActionSplitBtn from "../../../components/TakeActionSplitBtn/TakeActionSplitBtn";
import HorizontalStepperForActionRequired from "../../../components/HorizontalStepperForActionRequired/HorizontalStepperForActionRequired";
import PromotionRecentlyPromotedTile from "../../../components/PromotionRecentlyPromotedTile/PromotionRecentlyPromotedTile";
import RecentlyTransferredARTile from "../../../components/RecentlyTransferredARTile/RecentlyTransferredARTile";
import RecentlyRequestARTile from "../../../components/RecentlyRequestARTile/RecentlyRequestARTile";
import WarningHistoryARTile from "../../../components/WarningHistoryARTile/WarningHistoryARTile";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  allActions?: any;
  handleSubmitAR_Request: any;
  userId: any;
  historydata?: any;
}

const TerminationARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  trans,
  handleSubmitAR_Request,
  allActions,
  historydata,
  userId,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: "warning",
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : "",
        context: {},
        model: "warnings",
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans("Warning Action Required") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "5px",
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: "10px" }}>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.darkBlue,
                      fontSize: "1em",
                      fontWeight: "bold",
                    }}
                  >
                    {fullData?.first_name + " " + fullData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.grey_colorDesignationAR,
                      fontSize: "0.825em",
                    }}
                  >
                    {fullData?.department_name} / {fullData?.designation_name}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Applied On
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {fullData?.warning_date}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  marginTop: "0.5em",
                  width: "auto",
                  height: "30px",
                  flexDirection: "column",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: themes.defaultScondary_blue,
                  }}
                >
                  Description
                </Typography>
                <Typography
                  style={{
                    fontFamily: "Lato",
                    fontSize: "12px",
                    color: themes.greyModalTitle,
                  }}
                >
                  {fullData?.subject}
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  padding: "1em",
                  marginTop: "1em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "30px",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box style={{ display: "flex" }}>
                  <Avatar />
                  <Box style={{ paddingLeft: "1em" }}>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: themes.darkBlue,
                      }}
                    >
                      {fullData?.warning_by_first_name +
                        " " +
                        fullData?.warning_by_last_name}
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Lato",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: themes.greyDefault_500,
                        cursor: "pointer",
                      }}
                    >
                      Attachment
                    </Typography>
                  </Box>
                </Box>
                <Box
                  style={{
                    backgroundColor: "#FFEDEF",
                    borderRadius: "4px",
                    padding: "4px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "11px",
                      fontWeight: "bold",
                      color: "#FF5263",
                    }}
                  >
                    Warned
                  </Typography>
                </Box>
              </Box>
              <Box style={{ marginTop: "1.5em" }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              {allActions?.length > 0 && (
                <Box
                  style={{ marginTop: "1.5em", zIndex: "999", width: "100%" }}
                >
                  <TakeActionSplitBtn
                    onAction={(x: any) => handleTakeAction(x)}
                    menu={allActions}
                    title={"Take Action"}
                  />
                </Box>
              )}
            </Box>
          </Grid>
          {/* {Second Column} */}

          <Grid item xs={6}>
            <Box className="bg_border_ar_promotion">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.primaryMain,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Warning History
                </Typography>
              </Box>

              {historydata?.length > 0 &&
                historydata?.map((data: any, index: any) => {
                  return (
                    <div key={index}>
                      <WarningHistoryARTile
                        name={
                          data?.warning_for?.first_name +
                          " " +
                          data?.warning_for?.last_name
                        }
                        designation={
                          data?.warning_for?.emp_job_detail?.designation?.name
                        }
                        type={data?.subject}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>

          {/* {Horizontals Steps Label} */}
          {/* <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #0000001f",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <HorizontalStepperForActionRequired direction="horizontal" />
            </Box>
          </Grid> */}
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default TerminationARModalPresenter;
